import { FC } from "react";

import classNames from "classnames";

import { useTranslations } from "@jti/ui/providers/useTranslations";

import { ProductsMap } from "@/libs/commerce/products";

import { ProductCard } from "./ProductCard";
import { productCardInputs } from "./ProductCard.builder";

import styles from "./ProductCard.module.scss";

export type ProductCardWrapperProps = BuilderComponentProps<
  typeof productCardInputs
>;

export const ProductCardWrapper: FC<
  ProductCardWrapperProps & { products: ProductsMap }
> = ({
  products,
  sku,
  badge,
  attributes = {},
  secondaryButton,
  primaryButton,
  isPrimaryButtonHidden,
  isNewBadgeHidden,
}) => {
  const { __ } = useTranslations();
  const product = products[sku?.options?.product];

  const href = primaryButton?.href || product?.pageUrl;

  const primaryButtonConfig = {
    href,
    text: primaryButton?.text || __("product.button.buynow"),
    enabled: !isPrimaryButtonHidden,
  };
  const newProductBadgeLabel =
    product?.isNew && !isNewBadgeHidden ? __("product.badge.new") : "";

  const badgeLeft = badge?.left || newProductBadgeLabel;

  return (
    <div
      {...attributes}
      className={classNames(
        styles.productCardBuilderWrapper,
        attributes.className
      )}
    >
      <ProductCard
        sku={sku?.options?.product}
        title={product?.title}
        primaryButton={primaryButtonConfig}
        badge={{
          left: badgeLeft,
          right: badge?.right,
        }}
        description={product?.description}
        image={{
          src: product?.image || "",
          alt: `Image of ${product?.title}`,
        }}
        colors={product?.colors}
        secondaryButton={secondaryButton}
      />
    </div>
  );
};
